import AdditionalInfoForm from './AdditionalInfoForm'

export default AdditionalInfoForm
